import type { UseMutationResult } from '@tanstack/react-query';
import { useBffPostMutation } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';

export const useDownvoteReview = (reviewId: number): UseMutationResult =>
    useBffPostMutation(`/turn-to/reviews/${reviewId}/votedown`, [], [BffQueryKey.TURN_TO_DATA]);
